export default "__VITE_ASSET__75b09a8d__"